export const Config = { 
	authUrl: 'https://idm-cef-fiware.dit.upm.es/oauth2/authorize',
	clientId: 'smartsantander',
	redirectUri: 'https://eid-fiware.smartsantander.eu/oauth/redirect',
	apiUrl: 'https://eid-fiware.smartsantander.eu/api'
};
